<div class="ach-wrapper" [ngClass]="!displayMode ? ' page-content' : ''">
    <div *ngIf="ready">

        <!-- Not Found / Error -->
        <div *ngIf="!achInfo && !error" class="ach-empty">
            <i class="fa fa-exclamation-circle ach-empty__icon"></i>
            <p class="ach-empty__text">No ACH Found</p>
        </div>
        <div *ngIf="error" class="ach-result-card">
            <div class="ach-result-card__body">{{ error }}</div>
        </div>

        <div *ngIf="achInfo && !error">

            <!-- ── Header Banner ── -->
            <div class="ach-header">
                <div class="ach-header__left">
                    <div class="ach-header__eyebrow">ACH Payment Authorization</div>
                    <div class="ach-header__dealer">{{ achInfo.Dealer }}</div>
                    <div class="ach-header__meta">
                        <span class="ach-header__meta-label">ACH Code</span>
                        <span class="ach-header__code">{{ ach?.code }}</span>
                    </div>
                </div>
                <div class="ach-header__right">
                    <span *ngIf="!submitted" class="ach-badge ach-badge--pending">
                        <i class="fa fa-clock-o"></i> Pending Authorization
                    </span>
                    <span *ngIf="submitted && achInfo.Approved" class="ach-badge ach-badge--success">
                        <i class="fa fa-check-circle"></i> Approved
                    </span>
                    <span *ngIf="submitted && achInfo.Declined" class="ach-badge ach-badge--danger">
                        <i class="fa fa-times-circle"></i> Declined
                    </span>
                    <span *ngIf="submitted && !achInfo.Approved && !achInfo.Declined" class="ach-badge ach-badge--warning">
                        <i class="fa fa-file-text-o"></i> Submitted Manually
                    </span>
                </div>
            </div>

            <!-- ── Message Block ── -->
            <div class="ach-message-block" *ngIf="achInfo.Message">
                <p class="ach-message-block__main">{{ achInfo.Message }}</p>
                <p *ngIf="achInfo.Message2" class="ach-message-block__sub">{{ achInfo.Message2 }}</p>
            </div>

            <!-- ── Order Summary Cards ── -->
            <div class="ach-section" *ngIf="achInfo && achInfo.InvoiceNumber !== 0">
                <div class="ach-section__title">Order Details</div>
                <div class="ach-summary-grid">
                    <div class="ach-summary-card" *ngIf="achInfo.InvoiceNumber">
                        <div class="ach-summary-card__label">Sales Order</div>
                        <div class="ach-summary-card__value">#{{ achInfo.InvoiceNumber }}</div>
                    </div>
                    <div class="ach-summary-card" *ngIf="achInfo.PONumber">
                        <div class="ach-summary-card__label">PO Number</div>
                        <div class="ach-summary-card__value">{{ achInfo.PONumber }}</div>
                    </div>
                    <div class="ach-summary-card ach-summary-card--total">
                        <div class="ach-summary-card__label">Amount Due</div>
                        <div class="ach-summary-card__value ach-summary-card__value--money">{{ achInfo.Amount | currency }}</div>
                    </div>
                    <div class="ach-summary-card ach-summary-card--address">
                        <div class="ach-summary-card__label">Billing Address on File</div>
                        <div class="ach-summary-card__value ach-summary-card__value--address">
                            <span>{{ achInfo.BillAddress1 }}</span>
                            <span *ngIf="achInfo.BillAddress2">{{ achInfo.BillAddress2 }}</span>
                            <span>{{ achInfo.BillCity }}, {{ achInfo.BillState }} {{ achInfo.BillZip }}</span>
                            <span *ngIf="achInfo.Phone1"><i class="fa fa-phone me-1"></i>{{ achInfo.Phone1 }}</span>
                            <span *ngIf="achInfo.Email"><i class="fa fa-envelope me-1"></i>{{ achInfo.Email }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ── Manual Form Buttons ── -->
            <div *ngIf="manualFormEnabled" class="ach-manual-actions">
                <button class="ach-btn ach-btn--secondary" (click)="printAchForm()" [hidden]="readOnly || achInfo.Approved || achInfo.Declined" [disabled]="displayMode">
                    <i class="fa fa-print me-2"></i>Print ACH Form
                </button>
                <button class="ach-btn ach-btn--secondary" (click)="submittedManually()" [hidden]="readOnly || achInfo.Approved || achInfo.Declined" [disabled]="displayMode">
                    <i class="fa fa-check me-2"></i>Form Submitted Manually
                </button>
            </div>

            <!-- ── Banking Information Form ── -->
            <div class="ach-section" *ngIf="!submitted">
                <div class="ach-section__title">Banking Information</div>
                <div class="ach-form-row">
                    <div class="ach-form-fields">
                        <div class="ach-field-row">
                            <label class="ach-field-label">Account Type <span class="ach-required">*</span></label>
                            <dx-select-box [(value)]="achForm.accountType" [items]="accountTypes" width="250px" [disabled]="readOnly">
                                <dx-validator validationGroup="approveValidationGroup">
                                    <dxi-validation-rule type="required"></dxi-validation-rule>
                                </dx-validator>
                            </dx-select-box>
                        </div>
                        <div class="ach-field-row">
                            <label class="ach-field-label">Account Name <span class="ach-required">*</span></label>
                            <dx-text-box [(value)]="achForm.accountName" width="250px" [disabled]="readOnly">
                                <dx-validator validationGroup="approveValidationGroup">
                                    <dxi-validation-rule type="required"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                        <div class="ach-field-row">
                            <label class="ach-field-label">Bank Name <span class="ach-required">*</span></label>
                            <dx-text-box [(value)]="achForm.bankName" width="250px" [disabled]="readOnly">
                                <dx-validator validationGroup="approveValidationGroup">
                                    <dxi-validation-rule type="required"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                        <div class="ach-field-row">
                            <label class="ach-field-label">Account Number <span class="ach-required">*</span></label>
                            <dx-text-box [(value)]="achForm.accountNumber" width="220px" [disabled]="readOnly">
                                <dx-validator validationGroup="approveValidationGroup">
                                    <dxi-validation-rule type="required"></dxi-validation-rule>
                                    <dxi-validation-rule type="custom" message="Value must be a number" [validationCallback]="validateNumber" [reevaluate]="true"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                        <div class="ach-field-row">
                            <label class="ach-field-label">Routing Number <span class="ach-required">*</span></label>
                            <dx-text-box [(value)]="achForm.routingNumber" width="220px" [disabled]="readOnly">
                                <dx-validator validationGroup="approveValidationGroup">
                                    <dxi-validation-rule type="required"></dxi-validation-rule>
                                    <dxi-validation-rule type="custom" message="Value must be a number" [validationCallback]="validateNumber" [reevaluate]="true"></dxi-validation-rule>
                                    <dxi-validation-rule type="custom" message="Value must be 9 digits" [validationCallback]="validateNumberLength" [reevaluate]="true"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                        <div class="ach-field-row">
                            <label class="ach-field-label">Approved By <span class="ach-required">*</span></label>
                            <dx-text-box [(value)]="achForm.approvedBy" width="250px" [disabled]="readOnly">
                                <dx-validator validationGroup="approveValidationGroup">
                                    <dxi-validation-rule type="required"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </div>
                    <div class="ach-routing-image">
                        <img src="./assets/images/routing.png" />
                    </div>
                </div>

                <!-- Action Buttons -->
                <div class="ach-actions" *ngIf="!readOnly">
                    <button class="ach-btn ach-btn--approve" (click)="approve()" [disabled]="displayMode">
                        <i class="fa fa-check me-2"></i>Approve ACH
                    </button>
                    <button class="ach-btn ach-btn--decline" (click)="toggleShowDecline()" [disabled]="displayMode">
                        <i class="fa fa-times me-2"></i>Decline ACH
                    </button>
                </div>
            </div>

            <!-- ── Decline Panel ── -->
            <div *ngIf="showDecline && !submitted" class="ach-decline-panel">
                <div class="ach-decline-panel__title"><i class="fa fa-exclamation-triangle me-2"></i>Decline ACH Authorization</div>
                <div class="ach-decline-panel__body">
                    <div class="ach-decline-row">
                        <label class="ach-decline-label">Reason <span class="ach-required">*</span></label>
                        <dx-text-area [(value)]="achForm.declineReason" height="85" class="flex-fill">
                            <dx-validator validationGroup="declineValidationGroup">
                                <dxi-validation-rule type="required"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-area>
                    </div>
                    <div class="ach-decline-actions">
                        <button class="ach-btn ach-btn--decline" (click)="decline()"><i class="fa fa-paper-plane me-2"></i>Submit</button>
                        <button class="ach-btn ach-btn--ghost" (click)="toggleShowDecline()">Cancel</button>
                    </div>
                </div>
            </div>

            <!-- ── Completion Card ── -->
            <div *ngIf="submitted" class="ach-complete-card"
                [ngClass]="achInfo.Approved ? 'ach-complete-card--approved' : achInfo.Declined ? 'ach-complete-card--declined' : 'ach-complete-card--manual'">
                <div class="ach-complete-card__icon-wrap">
                    <i class="fa ach-complete-card__icon"
                        [ngClass]="achInfo.Approved ? 'fa-check-circle' : achInfo.Declined ? 'fa-times-circle' : 'fa-file-text-o'"></i>
                </div>
                <div class="ach-complete-card__content">
                    <div class="ach-complete-card__thanks">Thank you for your submission.</div>
                    <div class="ach-complete-grid">
                        <div class="ach-complete-item" *ngIf="achInfo.ApprovedBy">
                            <span class="ach-complete-item__label">Approved By</span>
                            <span class="ach-complete-item__value">{{ achInfo.ApprovedBy }}</span>
                        </div>
                        <div class="ach-complete-item">
                            <span class="ach-complete-item__label">Status</span>
                            <span class="ach-badge ach-badge--lg"
                                [ngClass]="achInfo.Approved ? 'ach-badge--success' : achInfo.Declined ? 'ach-badge--danger' : 'ach-badge--warning'">
                                {{ achInfo.Approved ? 'Approved' : achInfo.Declined ? 'Declined' : 'Submitted Manually' }}
                            </span>
                        </div>
                        <div class="ach-complete-item" *ngIf="achInfo.DeclineReason">
                            <span class="ach-complete-item__label">Decline Reason</span>
                            <span class="ach-complete-item__value">{{ achInfo.DeclineReason }}</span>
                        </div>
                        <div class="ach-complete-item">
                            <span class="ach-complete-item__label">Submitted On</span>
                            <span class="ach-complete-item__value">{{ submitted | date : 'MM/dd/yy' }}</span>
                        </div>
                        <div class="ach-complete-item" *ngIf="achInfo.ManualFormSelected">
                            <span class="ach-complete-item__value ach-complete-item__value--notice">
                                <i class="fa fa-info-circle me-1"></i>Orders will not be placed until funds have been withdrawn
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ── Invoice Transactions Table ── -->
            <div class="ach-section" *ngIf="achInfo.Type === 'Invoice'">
                <div class="ach-section__title">Invoice Transactions</div>
                <div class="ach-table-wrapper">
                    <table class="ach-table">
                        <thead>
                            <tr>
                                <th>Invoice Date</th>
                                <th>Invoice Number</th>
                                <th class="ach-table__money">Starting Balance</th>
                                <th class="ach-table__money">Payments</th>
                                <th class="ach-table__money">Remaining Balance</th>
                                <th class="ach-table__money">Amount Due</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let transaction of achInfo.Transactions">
                                <td>{{ transaction.InvoiceDate | date: 'MM/dd/yyyy' }}</td>
                                <td>{{ transaction.InvoiceNumber }}</td>
                                <td class="ach-table__money">{{ transaction.StartingBalance | currency }}</td>
                                <td class="ach-table__money">{{ transaction.Payments | currency }}</td>
                                <td class="ach-table__money">{{ transaction.RemainingBalance | currency }}</td>
                                <td class="ach-table__money">{{ transaction.RemainingBalance | currency }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    </div>
</div>
